import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { HomeModularComponent } from './home.component';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule, Routes } from '@angular/router';
import { BannerComponent } from './components/banner/banner.component';

const routes: Routes = [
  { 
    path: '', 
    component: HomeModularComponent,
    children: [
      {
        path: 'banner',
        component: BannerComponent
      }
    ]
  }
];

@NgModule({
  declarations: [
    HomeModularComponent,
    BannerComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
    TranslateModule,
    MatSnackBarModule
  ],
  providers: [
  ],
  exports: [
    HomeModularComponent
  ]
})
export class HomeModuleModule { }
